import { createServerFn } from "@tanstack/react-start";
import { whoami } from "@/lib/mma";
import { useAppSession } from "@/utils/session";
import { resolveClientIp } from "@/lib/utils.server";
import consola from "consola";

const logger = consola.withTag("auth");

export const login = createServerFn({ method: "POST" })
  .inputValidator((data: { username: string; password: string }) => data)
  .handler(async ({ data }) => {
    const clientIp = resolveClientIp();
    const token = Buffer.from(`${data?.username}:${data?.password}`).toString("base64");
    const baseUrl = process.env.API_BASE_URL;

    logger.info("Login attempt for %s from %s → %s", data.username, clientIp, baseUrl);

    const response = await whoami({
      baseUrl,
      headers: {
        Authorization: `Basic ${token}`,
        Forwarded: `for=${clientIp}`,
      },
    });

    if (response.response.status !== 200) {
      logger.warn("Login failed for %s: HTTP %d", data.username, response.response.status);
      if (response.response.status === 401) {
        throw new Error("Invalid username or password");
      }
      if (response.response.status === 403) {
        throw new Error("User is not active");
      }
      if (response.response.status === 404) {
        throw new Error("User not found");
      }
      if (response.response.status === 500) {
        throw new Error("Internal server error");
      }
      throw new Error("An error occurred while logging in");
    }

    logger.info("Login successful for %s (profile: %s)", response.data?.data?.username, response.data?.data?.profile?.id);

    // Create a session
    const session = await useAppSession();

    // Store the user's credentials and other information in the session
    await session.update({
      username: response.data?.data?.username,
      displayName: response.data?.data?.displayName ?? undefined,
      profile: response.data?.data?.profile?.id?.toString() || "0",
      clientIp: clientIp,
      token,
      baseUrl,
    });
  });
